export const ROUTER_OUTLET_SELECTOR = '#root';
export const CONTAINER_ROOT_SELECTOR = '#container-module';

export const HOSTED_ENVANY_DOMAIN = 'envany.localhost.abovecloud.io';

export const MODULE_CLASS = 'container-module';
